import { useEffect, useState } from 'react';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { getShowCommunityImages, setShowCommunityImages, COMMUNITIES_DEFAULT_HIDE_IMAGE } from 'src/utils/imagePreferences';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { LinkButton } from 'styles-js/buttons';
import Button from 'src/components/buttons/button';

export default function ImagePlaceMarker({ children, communityId }) {
  const [isImageHidden, setIsImageHidden] = useState(COMMUNITIES_DEFAULT_HIDE_IMAGE.includes(communityId));
  const [rememberMyChoice, setRememberMyChoice] = useState(false);

  useEffect(() => {
    setIsImageHidden(!getShowCommunityImages(communityId));
  }, [communityId, setIsImageHidden]);

  const onShowImage = () => {
    if (rememberMyChoice) setShowCommunityImages(communityId, true);
    setIsImageHidden(false);
  };

  if (!isImageHidden) return children;

  return (
    <PlaceMarker data-testid="post-image-placemarker">
      <Text>
        {i18n.t('Images are hidden by default on this community.')}{' '}
        <LinkButton onClick={() => helpScoutArticle('142-images-hidden-by-default')}>{i18n.t('Learn more')}</LinkButton>
      </Text>
      <ActionsContainer>
        <StyledButton
          data-testid="showImageBtn"
          text={i18n.t('Show image')}
          onClick={onShowImage}
        />
        <Label>
          <Input
            checked={rememberMyChoice}
            type="checkbox"
            onChange={() => setRememberMyChoice(!rememberMyChoice)}
          />
          {i18n.t('Remember my choice on this device')}
        </Label>
      </ActionsContainer>
    </PlaceMarker>
  );
}

const PlaceMarker = styled.div`
  padding: 15px;
  background: ${({ theme }) => theme.colorBlueBackground};
  margin-bottom: 30px;

  @media (${({ theme }) => theme.overScreenXsmall}) {
    padding: 30px 15px;
    text-align: center;
  }
`;

const Text = styled.p`
  margin-bottom: 10px;
`;

const ActionsContainer = styled.div`
  @media (${({ theme }) => theme.overScreenXsmall}) {
    display: inline-flex;
  }
`;

const StyledButton = styled(Button)`
  margin-right: 16px;

  @media (${({ theme }) => theme.underScreenXsmall}) {
    margin-bottom: 10px;
  }
`;

const Label = styled.label`
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;
  font-size: ${({ theme }) => theme.fontSizeXs};
  cursor: pointer;
`;

const Input = styled.input`
  width: 15px;
  height: 15px;
  margin-right: 8px;
`;
